enum ErrorScope {
  DESIGN_STUDIO = 'Design Studio',
}

export { ErrorScope };
